import React, { Component } from 'react';
import _                    from 'lodash'
import { DragDropContext, Droppable, Draggable }  from 'react-beautiful-dnd'

import {
  Button,
  Header,
  Modal,
  Table,
  Icon,
  Label,
} from 'semantic-ui-react'

import utils                from '../../utils'
import firebase             from '../../config/firebase'

class RestaurantByCategory extends Component {
  constructor() {
    super()

    this.state = {
      arrangeRestaurants: [],
      hasArranged: false,
      addRestaurantVisible: false,
      selectedRestaurants: []
    }
  }

  componentDidMount() {
    const { restaurants } = this.props
    if (_.size(restaurants) > 0) {
      this.generateDragDropItem(restaurants)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { restaurants } = this.props
    if (restaurants !== nextProps.restaurants) {
      if (_.size(nextProps.restaurants) > 0) {
        this.generateDragDropItem(nextProps.restaurants)
      } else {
        this.setState({ arrangeRestaurants: [], hasArranged: false })
      }
    }
  }

  generateDragDropItem = restaurants => {
    const { categoryKey } = this.props
    const orderByListing  = _.orderBy(restaurants, (restaurant) => restaurant.listing_orders && restaurant.listing_orders[categoryKey], ['asc'])

    const arrangeRestaurants = _.map(orderByListing, restaurant => ({
      id: restaurant.key,
      content: restaurant.name,
      rate: restaurant.rate,
      rating_count: restaurant.rating_count || 0,
      order: (restaurant.listing_orders && restaurant.listing_orders[categoryKey]) || '',
    }))

    this.setState({ arrangeRestaurants, hasArranged: false })
  }

  getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    padding: 10,
    margin: `4px 0 4px 0`,
    background: isDragging ? 'black' : '#e0e1e2',
    width: '500px',
    borderRadius: `5px`,
    color: isDragging ? 'white' : 'rgba(0,0,0,.8)',
    ...draggableStyle,
  })

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  }

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const { arrangeRestaurants } = this.state

    const items = this.reorder(
      arrangeRestaurants,
      result.source.index,
      result.destination.index
    );

    this.setState({ arrangeRestaurants: items, hasArranged: true })
  }

  shuffleRestaurant = () => {
    let { arrangeRestaurants } = this.state

    arrangeRestaurants = _.shuffle(arrangeRestaurants).map((restaurant, index)=> ({ ...restaurant, order: index }))

    this.setState({ arrangeRestaurants, hasArranged: true })
  }

  sortByRating = () => {
    let { arrangeRestaurants } = this.state

    arrangeRestaurants = _.orderBy(arrangeRestaurants, ['rating_count', 'rate'], ['desc', 'desc']).map((restaurant, index) => ({ ...restaurant, order: index }))

    this.setState({ arrangeRestaurants, hasArranged: true })
  }

  updateListingOrder = () => {
    const self = this
    const { arrangeRestaurants } = this.state
    const { categoryKey, setUpdateListing } = this.props
    const updates = {}

    _.map(arrangeRestaurants, (restaurant, index) => {
      updates[`restaurants/${restaurant.id}/listing_orders/${categoryKey}`] = index+1
    })

    setUpdateListing(true)
    firebase.database().ref().update(updates).then(err => {
      if (err) { alert(err) }

      self.props.setUpdateListing(false)
      if (categoryKey !== 'all') {
        self.props.refreshData(categoryKey)
      }
    })
  }

  removeFromCategory = restaurant => {
    const { categoryKey, auth, refreshData } = this.props
    const conf = window.confirm(`Are you sure to remove ${restaurant.content} from this category?`)

    if (conf) {

      if (categoryKey === 'all') {
        return;
      }

      const updates = {}
      updates[`restaurants/${restaurant.id}/categories/${categoryKey}`] = null
      updates[`restaurants/${restaurant.id}/categories/${auth.region}/${categoryKey}`] = null
      updates[`restaurants/${restaurant.id}/listing_orders/${categoryKey}`] = null

      firebase.database().ref().update(updates).then((err) => {
        if (err) {
          alert(err)
        }

        refreshData(categoryKey)
      })
    }
  }

  renderRestaurantList = () => {
    const { updating, categoryKey } = this.props
    const { arrangeRestaurants } = this.state

    if (_.size(arrangeRestaurants) > 0) {
      return (
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div ref={provided.innerRef} className="drag-drop-restaunrant-wrapper">
                {
                  _.map(arrangeRestaurants, (restaurant, index) => (
                    <Draggable key={restaurant.id} draggableId={restaurant.id} index={index} isDragDisabled={updating}>
                      {(provided, snapshot) => (
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={this.getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                          >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', flex: 1 }}>
                              <div>
                                {
                                  restaurant.order !== '' &&
                                  <Label color='red' horizontal>
                                    { restaurant.order }
                                  </Label>
                                }
                              </div>
                              <div style={{ flex: 1, marginLeft: 5, marginRight: 5 }}>
                                { restaurant.content }
                              </div>
                              <div>
                                <Icon name="align justify" />
                              </div>
                            </div>
                          </div>
                          {
                            !snapshot.isDragging && categoryKey !== 'all' &&
                            <div style={{ marginLeft: 8 }}>
                              <Button icon="remove" color="red" onClick={() => this.removeFromCategory(restaurant)} />
                            </div>
                          }
                        </div>
                      )}
                    </Draggable>
                  ))
                }
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )
    }

    if (categoryKey !== 'all') {
      return (
        <div>
          There are no restaurants in this category.
        </div>
      )
    }
      return (
        <div>
          There are no restaurants to show.
        </div>
      )

  }

  toggleSelectedRestaurants = restaurantKey => {
    const { selectedRestaurants } = this.state
    let newArr = []

    if (_.includes(selectedRestaurants, restaurantKey)) {
      newArr = _.filter(selectedRestaurants, (key) => key !== restaurantKey)
    } else {
      newArr = _.concat(selectedRestaurants, restaurantKey)
    }

    this.setState({ selectedRestaurants: newArr })
  }

  renderCurrentCategory = restaurant => {
    const { allCategoryData } = this.props

    if (restaurant.categories) {
      const categoryKeys = Object.keys(restaurant.categories)

      const categories = _.map(categoryKeys, key => {
        if (allCategoryData[key] && allCategoryData[key].name) {
          return (
            <Label key={key} size="small">
              {allCategoryData[key].name}
            </Label>
          )
        }
      })

      return categories
    }
  }

  renderAddRestaurantList = () => {
    const { selectedRestaurants } = this.state
    const { restaurants, allPublishedRestaurants } = this.props
    const restaurantKeys = _.map(restaurants, (restaurant) => restaurant.key)

    const availableRestaurants = _.map(allPublishedRestaurants, restaurant => {
      if (!_.includes(restaurantKeys, restaurant.key)) {
        const isActive = _.includes(selectedRestaurants, restaurant.key)

        return (
          <Table.Row key={restaurant.key} onClick={() => this.toggleSelectedRestaurants(restaurant.key)} active={isActive}>
            <Table.Cell>
              <div className="add-restaurant-category-row">
                <div className="add-restaurant-category-current-categories">
                  <div style={{ marginBottom: 5, fontWeight: 'bold', fontSize: 16 }}>
                    {restaurant.name}
                  </div>
                  <div>
                    { this.renderCurrentCategory(restaurant) }
                  </div>
                </div>
                {
                  isActive &&
                  <div>
                    <Icon name="check" color="green" />
                  </div>
                }
              </div>
            </Table.Cell>
          </Table.Row>
        )
      }
    })

    return (
      <div className="modal-add-restaurant-category">
        <Table celled selectable>
          <Table.Body>
            {
              _.size(availableRestaurants) > 0 ?
                availableRestaurants
              :
                <Table.Row>
                  <Table.Cell>No availableRestaurants</Table.Cell>
                </Table.Row>
            }
          </Table.Body>
        </Table>
      </div>
    )
  }

  addCategoryRestaurants = () => {
    const self = this
    const { selectedRestaurants } = this.state
    const { categoryKey, auth } = this.props
    const { region = utils.constants.REGION.PHNOM_PENH } = auth

    const updates = {}

    if (categoryKey === 'all') {
      return;
    }

    this.setState({ adding: true })

    _.map(selectedRestaurants, (restKey) => {
      updates[`restaurants/${restKey}/categories/${categoryKey}`] = true
      updates[`restaurants/${restKey}/categories/${region}/${categoryKey}`] = true
    })


    firebase.database().ref().update(updates).then(err => {
      if (err) {
        alert(err)
      }

      self.setState({ adding: false, addRestaurantVisible: false, selectedRestaurants: [] }, () => {
        if (categoryKey !== 'all') {
          self.props.refreshData(categoryKey)
        }
      })
    })
  }

  removeAllRestaurant = () => {
    const { arrangeRestaurants } = this.state
    const { categoryKey, auth, refreshData } = this.props

    const conf = window.confirm('Are you sure to remove all restaurants from this category?')

    if (conf) {
      const updates = {}

      if (categoryKey === 'all') {
        return;
      }

      _.map(arrangeRestaurants, (restaurant) => {
        updates[`restaurants/${restaurant.id}/categories/${categoryKey}`] = null
        updates[`restaurants/${restaurant.id}/categories/${auth.region}/${categoryKey}`] = null
        updates[`restaurants/${restaurant.id}/listing_orders/${categoryKey}`] = null
      })

      firebase.database().ref().update(updates).then(err => {
        if (err) { alert(err) }

        refreshData(categoryKey)
      })
    }
  }

  sortByDistance = () => {
    const { allCategoryData, categoryKey, updateSelectCategory, isSortingByDistance, handleUpdateSortByDistanceConfig } = this.props
    let sortByDistance = !isSortingByDistance
    if (categoryKey === 'all') {
      handleUpdateSortByDistanceConfig(sortByDistance)
    } else {
      const category = allCategoryData[categoryKey]
      sortByDistance = !category.is_sort_by_distance
      updateSelectCategory(category.menu_key, categoryKey, { ...category, is_sort_by_distance: sortByDistance })
    }
  }

  shuffleSameDeliveryFee = () => {
    const { allCategoryData, categoryKey, handleShuffleSameDeliveryFeeByCategory, isShuffleSameDeliveryFee, handleUpdateShuffleSameDeliveryFeeConfig } = this.props
    let shuffleSameDeliveryFee = !isShuffleSameDeliveryFee
    if (categoryKey === 'all') {
      handleUpdateShuffleSameDeliveryFeeConfig(shuffleSameDeliveryFee)
    } else {
      const category = allCategoryData[categoryKey]
      shuffleSameDeliveryFee = !category.is_shuffle_same_delivery_fee
      handleShuffleSameDeliveryFeeByCategory(category.menu_key, categoryKey, { ...category, is_shuffle_same_delivery_fee: shuffleSameDeliveryFee })
    }
  }

  render() {
    const { allCategoryData, categoryKey, restaurants, loading, updating, isSortingByDistance, isShuffleSameDeliveryFee } = this.props
    const { selectedRestaurants, arrangeRestaurants, hasArranged, addRestaurantVisible, adding } = this.state
    let category = {}
    let headerLabel = `List Restaurants`

    if (categoryKey !== 'all' && (allCategoryData[categoryKey] && allCategoryData[categoryKey].name)) {
      category = allCategoryData[categoryKey]
      headerLabel = `List Restaurants ${allCategoryData[categoryKey].name} (${_.size(restaurants)})`
    }
    const isSortByDistance = categoryKey === 'all' ? isSortingByDistance : category.is_sort_by_distance
    const shuffleSameDeliveryFee = categoryKey === 'all' ? isShuffleSameDeliveryFee : category.is_shuffle_same_delivery_fee

    return (
      <div className="restaurant-category-tab-content-child-wrapper">
        <div style={{ display: 'flex', flexDirection: 'row', height: 50, alignItems: 'center', justifyContent: 'space-between', padding: 10 }}>
          <Header style={{ margin: 0, flex: 1 }} size='medium'>
            {headerLabel}
          </Header>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', height: 50, alignItems: 'center', justifyContent: 'flex-end', padding: 10 }}>
          {
            _.size(arrangeRestaurants) > 0 && categoryKey !== 'all' &&
            <Button icon color='red' onClick={() => this.removeAllRestaurant()} disabled={loading || updating}>
              Remove all restaurants
            </Button>
          }
          {
            categoryKey !== 'all' &&
            <Button icon color='black' onClick={() => this.setState({ addRestaurantVisible: true })} disabled={loading || updating}>
              Add Restaurant
            </Button>
          }
          {
            categoryKey === 'all' && (
              <Button icon color='orange' onClick={() => this.sortByRating()} disabled={loading || updating || isSortByDistance}>
                Sort by Rating
              </Button>
            )
          }
          <Button icon color='orange' onClick={() => this.shuffleRestaurant()} disabled={loading || updating || isSortByDistance}>
            Shuffle
          </Button>
          <Button icon color="orange" onClick={this.sortByDistance} disabled={loading || updating}>
            <Icon name={isSortByDistance ? 'check square outline' : 'square outline'} /> Sort by Distance
          </Button>
          <Button icon color="orange" onClick={this.shuffleSameDeliveryFee} disabled={loading || updating || !isSortByDistance}>
            <Icon name={shuffleSameDeliveryFee ? 'check square outline' : 'square outline'} /> Shuffle Same Delivery Fee
          </Button>
        </div>

        <div className="restaurant-category-tab-content-restaurant-child">
          { this.renderRestaurantList() }
        </div>
        <div style={{ margin: '10px 10px 10px 15px' }}>
          {
            _.size(restaurants) > 0 &&
            <Button disabled={loading || updating || !hasArranged} onClick={() => this.updateListingOrder()} loading={updating}>
              Save
            </Button>
          }
        </div>
        <Modal
          open={addRestaurantVisible}
          style={{ marginTop: 0 }}
          closeOnEscape={false}
          closeOnDimmerClick={false}
        >
          <Modal.Header>
            <div className="add-restaurant-category-row">
              <div style={{ flex: 1 }}>
                Add Restaurant to category
              </div>
              { _.size(selectedRestaurants) > 0 && `(Selected: ${_.size(selectedRestaurants)})` }
            </div>
          </Modal.Header>
          <Modal.Content>
            { this.renderAddRestaurantList() }
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={() => this.setState({ addRestaurantVisible: false, selectedRestaurants: [] })} disabled={adding}>
              Cancel
            </Button>
            <Button
              loading={adding}
              onClick={() => this.addCategoryRestaurants()}
              color="black"
              labelPosition='right'
              icon='save'
              content='Save'
            />
          </Modal.Actions>
        </Modal>
      </div>
    )
  }
}

export default RestaurantByCategory


// WEBPACK FOOTER //
// ./src/components/restaurants/restaurantByCategory.js